import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicPageStandardResponsive = _resolveComponent("PublicPageStandardResponsive")!
  const _component_PublicPageStandardFixedSize = _resolveComponent("PublicPageStandardFixedSize")!

  return (_ctx.publicPageData.layoutSize === _ctx.PublicPageLayoutSize.RESPONSIVE)
    ? (_openBlock(), _createBlock(_component_PublicPageStandardResponsive, {
        key: 0,
        ref: "responsive",
        isPreview: _ctx.isPreview,
        kiwiIframeURL: _ctx.kiwiIframeURL,
        publicPageData: _ctx.publicPageData,
        publicPageTitle: _ctx.publicPageTitle,
        projectUserName: _ctx.projectUserName,
        viewLayoutRequest: _ctx.viewLayoutRequest,
        commentOK: _ctx.commentOK
      }, null, 8, ["isPreview", "kiwiIframeURL", "publicPageData", "publicPageTitle", "projectUserName", "viewLayoutRequest", "commentOK"]))
    : (_openBlock(), _createBlock(_component_PublicPageStandardFixedSize, {
        key: 1,
        ref: "fixedSize",
        isPreview: _ctx.isPreview,
        kiwiIframeURL: _ctx.kiwiIframeURL,
        publicPageData: _ctx.publicPageData,
        publicPageTitle: _ctx.publicPageTitle,
        projectUserName: _ctx.projectUserName,
        viewLayoutRequest: _ctx.viewLayoutRequest,
        commentOK: _ctx.commentOK
      }, null, 8, ["isPreview", "kiwiIframeURL", "publicPageData", "publicPageTitle", "projectUserName", "viewLayoutRequest", "commentOK"]))
}